import styled from 'styled-components';
import {Column, Row} from '../../common/Layouts/Layouts';

export const HiddenDropdownWrapperDiv = styled.div`
  width: ${props => props.width || '20rem'};
  top: ${props => props.top || '1.5rem'};
  right: ${props => props.right || '0'};
  max-width: ${props => props.right || '30rem'};
  padding: ${props => props.theme.spacing.base} 0;
  z-index: ${props => props.theme.misc.zIndex.base};
  visibility: hidden;
  transition: opacity 0.8s;
  position: absolute;
  /* left: 0; */
`;

export const HoverTargetWrapperDiv = styled.div`
  position: relative;
  text-align: left;
  display: inline-flex;
  /* align-self: flex-start; */
  &:hover > ${HiddenDropdownWrapperDiv} {
    visibility: visible;
  }
`;

export const TopDiv = styled.div(
  props => `
background-color: ${props.theme.colors.goWhite.base};
border-radius: ${props.theme.misc.borderRadius.base};
box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)} ${
    props.theme.colors.shadow.base
  };
`,
);

const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
    background: white;
  }
`;

export const TipPositioning = styled(TipUI)`
  right: 15%;
  top: -0.2rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props => props.bgColor};
    box-shadow: 0 ${props => props.theme.spacing.xxsmall} ${props => props.theme.spacing.custom(4)}
      ${props => props.theme.colors.shadow.base};
  }
`;

// CONTENT STUFF

export const ListDropDownWrapper = styled.div(
  props => `
width: 100%;
display: flex;
list-style-type: none;
overflow: hidden;
padding: ${props.theme.spacing.small} 0 0;
flex-direction: column;
> li {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding: ${props.theme.spacing.base};
  position: relative;
  &:last-child {
    border-bottom: none;
  }
}
`,
);

export const TextBlockDropDownWrapper = styled(Column)`
  padding: ${props => props.theme.spacing.large};
  color: ${props => props.color};
  background-color: ${props => props.bgColor};
`;

export const TextBlockDDHeading = styled(Row)`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  padding: ${props => props.theme.spacing.custom(3)} ${props => props.theme.spacing.base}
    ${props => props.theme.spacing.custom(3)} ${props => props.theme.spacing.small};
  background-color: ${props => props.bgColor};
  color: ${props => props.color};
  border-radius: 2.5rem;
`;

export const TextBlockDDHeadingSpan = styled.span`
  color: ${props => props.color || props.theme.colors.goGreen.base};
  padding: 0 0 0 ${props => props.theme.spacing.small};
`;

export const TextBlockDDFilterText = styled.p`
  line-height: 1.3;
  font-size: ${props => props.theme.font.custom(14)};
  padding-top: ${props => props.theme.spacing.base};
`;

export const BlueLinkText = styled.span`
  color: ${props => props.theme.colors.goBrandBlue.base};
`;

export const FontBoldSpan = styled.span`
  font-weight: bold;
`;

export const FontBigBold = styled.span(
  props => `
  // font-weight: bold;
  font-size: ${props.theme.font.custom(14)};
`,
);

export const WrapperSpan = styled.span(
  props => `
  display:flex;
  align-items:center;
  padding: 0 ${props.theme.spacing.small};
  color: ${props.theme.colors.goBrandBlue.base};
`,
);

export const SortingDropDownWrapper = styled.div(
  props => `
width: 100%;
display: flex;
list-style-type: none;
overflow: hidden;
padding: ${props.theme.spacing.small} 0 0;
flex-direction: column;
> li {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding: ${props.theme.spacing.base};
  position: relative;
  &:last-child {
    border-bottom: none;
  }
}
`,
);

export const RadioCheck = styled.input.attrs({type: 'radio'})(
  props => `
  width: 1.5rem;
  height: 1.5rem;
  align-items: center;
  justify-content: center;
  margin-right: ${props.theme.spacing.small};
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;

`,
);
